export default __webpack_public_path__ + "static/universe-1-e470efcb3885e1acde87704c3e987bf3.webp";